import { SessionStatusEnumType } from '@/features/sessions/types'

// Etat affiche par la carte de session du fil, a partir du statut de la
// session, du statut de l'utilisateur et de l'heure.
export type SessionCardStateType =
  | 'toConfirm'
  | 'planned'
  | 'ongoing'
  | 'toComplete'
  | 'waitReviews'
  | 'finished'
  | 'cancelled'

// « Rejoindre » apparait a partir de 2 h avant le debut (meme regle que le panneau de contexte)
export const SESSION_JOIN_WINDOW_HOURS = 2

export function getSessionCardState({
  status,
  myStatus,
  from,
  to,
  now,
  othersWaiting = false,
}: {
  status: SessionStatusEnumType
  myStatus?: SessionStatusEnumType
  from: string
  to: string
  now: number
  // un autre participant n'a pas encore repondu : le statut de la session est
  // celui de l'utilisateur, donc « Planifiee » pour le mentor qui a propose
  othersWaiting?: boolean
}): SessionCardStateType {
  if (othersWaiting && status === SessionStatusEnumType.PLANNED && now < new Date(from).getTime()) {
    return 'toConfirm'
  }
  switch (status) {
    case SessionStatusEnumType.WAIT_CONFIRMATION:
      return 'toConfirm'
    case SessionStatusEnumType.CANCELLED:
      return 'cancelled'
    case SessionStatusEnumType.FINISHED:
      return 'finished'
    case SessionStatusEnumType.WAIT_REVIEW:
      // « A completer » seulement pour qui doit encore rendre son compte rendu
      return myStatus === SessionStatusEnumType.WAIT_REVIEW ? 'toComplete' : 'waitReviews'
    default: {
      const start = new Date(from).getTime()
      const end = new Date(to).getTime()
      return now >= start && now < end ? 'ongoing' : 'planned'
    }
  }
}

export function getSessionDurationParts(from: string, to: string): { hours: number; minutes: number } {
  const total = Math.max(0, Math.round((new Date(to).getTime() - new Date(from).getTime()) / 60_000))
  return { hours: Math.floor(total / 60), minutes: total % 60 }
}
